module.exports = __webpack_public_path__ + "static/media/icon_epinglage.fda3c6e9.svg";